import React from 'react';
import OrderEditor from '../common/OrderEditor';
import { purchaseOrdersAPI, vendorsAPI } from '../../services/api';

export default function PurchaseOrderForm() {
  return (
    <OrderEditor
      title="Purchase Order"
      api={purchaseOrdersAPI}
      basePath="/purchase-orders"
      partyLabel="Vendor"
      loadParties={() => vendorsAPI.list({})}
      idField="vendor_id"
      nameField="vendor_name"
      dateField="order_date"
      secondLabel="Expected Date"
      secondField="expected_date"
      statuses={['Draft', 'Submitted', 'PartiallyReceived', 'Received', 'Closed', 'Cancelled']}
    />
  );
}
